<div class="container py-4">

  <!-- 🔷 TÍTULO -->


  <!-- 🟥 BANNER -->
  <div class="banner-ia">
    <div class="banner-left">
      <img src="assets/banners_carreras/SISTEMASCOM2.jpg" alt="IA">
    </div>
  </div>

  <!-- 📘 INFO PRINCIPAL -->
  <section class="info-section">

    <div class="info-block">
      <h3>■ OBJETIVO GENERAL</h3>
      <p>
       Formar profesionistas líderes con una visión estratégica capaces de implementar diferentes tecnologías a través del desarrollo de proyectos de sistemas de información aplicando conocimientos de administración de sistemas operativos y base de datos, redes de computadoras y programación para la creación de soluciones innovadoras con alto impacto en beneficio de la sociedad.
      </p>
    </div>



    <div class="info-block">
      <h3>■ MISIÓN</h3>
      <p>
        Formar profesionistas emprendedores con visión estratégica, humanismo, ética, liderazgo, capaces de diseñar, implementar y administrar infraestructura computacional vinculada a las demandas de la zona sur del estado de Campeche; contando con una plantilla docente proactiva y líderes en su área de conocimiento
      </p>
    </div>

    <div class="info-block">
      <h3>■ VISIÓN</h3>
      <p>
       Ser la carrera profesional de mayor impacto en la zona sur del estado de Campeche, ofreciendo soluciones tecnológicas e innovadoras en beneficio de la sociedad, en un contexto global, multidisciplinario y sustentable.
      </p>
    </div>

  </section>

  <!-- 🧠 TABS -->
  <div class="tabs-box">

    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab1">
          Perfil de Ingreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2">
          2. Perfil de Egreso
        </button>
      </li>

        <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3">
          3. Objetivos Educacionales
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab4">
          4. Atributos de Egreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab5">
          5. Acreditación
        </button>
      </li>
    </ul>

    <div class="tab-content">

      <!-- TAB 1 -->
      <div id="tab1" class="tab-pane fade show active">
        <ul>
          <li>Conocimientos en las áreas de físico matemático.</li>
          <li>Criterio y razonamiento lógico para la solución de problemas.</li>
          <li>Habilidad de comprensión lectora en lengua materna y un segundo idioma.</li>
          <li>Disposición para el trabajo multidisciplinario</li>
          <li>Mostrar interés por las Tecnologías de la Información y Comunicación</li>
          <li>Tener actitud ética y cuidado del medio ambiente y la sociedad, para lograr una formación integral, que le permitan alcanzar los objetivos educacionales.</li>
        </ul>
      </div>

      <!-- TAB 2 -->
      <div id="tab2" class="tab-pane fade">

        <ul>
        <li>Implementa aplicaciones computacionales para solucionar problemas de diversos contextos, integrando diferentes tecnologías, plataformas o dispositivos</li>
        <li>Diseña, desarrolla y aplica modelos computacionales para solucionar problemas, mediante la selección y uso de herramientas matemáticas.</li>
        <li>Diseña e implementa interfaces para la automatización de sistemas de hardware y desarrollo del software asociado.</li>
        <li>Coordina y participa en equipos multidisciplinarios para la aplicación de soluciones innovadoras en diferentes contextos</li>
        <li>Diseña, implementa y administra bases de datos optimizando los recursos disponibles, conforme a las normas vigentes de manejo y seguridad de la información</li>
        <li>Desarrolla y administra software para apoyar la productividad y competitividad de las organizaciones cumpliendo con estándares de calidad.</li>
        <li>Evalúa tecnologías de hardware para soportar aplicaciones de manera efectiva</li>
        <li>Detecta áreas de oportunidad empleando una visión empresarial para crear proyectos aplicando las Tecnologías de la Información y Comunicación.</li>
        <li>Diseña, configura y administra redes de computadoras para crear soluciones de conectividad en la organización, aplicando las normas y estándares vigentes.</li>
        </ul>
      </div>


        <div id="tab3" class="tab-pane fade">
        <ul>
          <li>Diseñar, implementar y administrar bases de datos conforme a los estándares vigentes de seguridad para mantener la integridad de la información.</li>
          <li>Diseñar, configurar y administrar redes de computadoras para crear soluciones de conectividad, aplicando las normas y estándares vigentes.</li>
          <li>Diseñar, desarrollar, configurar e implementar soluciones computacionales e innovadoras cubriendo las necesidades de la sociedad a través de tecnologías emergentes en diferentes contextos con responsabilidad ética y social.</li>
          <li>Aplicar, implementar y promover bases científicas, metodológicas y éticas que le permitan integrarse en el ambiente laboral como un agente de cambio fomentando el desarrollo sustentable acorde a las necesidades de su entorno.</li>
        </ul>
       

          </div>

     
      <div id="tab4" class="tab-pane fade">
        
        <ul>
          <li>Identifica, formula y resuelve problemas de ingeniería computacional aplicando los principios de las ciencias básicas e ingeniería.</li>
          <li>Aplica metodologías para el análisis y diseño de soluciones tecnológicas que cumplen las necesidades especificadas.</li>
          <li>Desarrolla y conduce proyectos de tecnología computacional y/o científicos para analizar e interpretar datos y utilizar el juicio ingenieril para la toma de decisiones y análisis de resultados.</li>
          <li>Comunica y colabora efectivamente con equipos multidisciplinarios que le permitan analizar, planificar y desarrollar proyectos de tecnología computacional</li>
          <li>Reconoce sus responsabilidades éticas y profesionales al generar soluciones computacionales, en el contexto global, económico, ambiental y social.</li>
          <li>Reconoce la necesidad de actualización en tendencias del ámbito tecnológico que le permita tener la habilidad para localizar, evaluar, integrar y aplicar este conocimiento adecuadamente</li>
          <li>Dirige y/o participa en equipos de trabajo para analizar, planear, gestionar, y ejecutar tareas para el cumplimiento de metas de proyectos de tecnología computacional.</li>
        </ul>
      </div> 


           <div id="tab5" class="tab-pane fade">
              <h5>"Programa Acreditado por el Consejo de Acreditación de la Enseñanza de la Ingeniería con vigencia hasta Diciembre de 2028"</h5>
            <br>
           <div class="tab-image-wrapper">
            
          <img src="assets/banners_carreras/logo cacei.jpg" alt="Información de la carrera" class="tab-image">

     </div>

    </div>

  </div>

  <!--DOCUMENTACIÓN -->
  <div class="doc-section text-center">
    <img src="assets/banners_carreras/logo_drive.png" class="doc-icon">
    <br>
    <a href="https://drive.google.com/drive/folders/1-qokWUfZ5TwVO9QYOXYKNH9xsGKQf-Jw" target="_blank"
      class="doc-link">
      ■ DOCUMENTACIÓN INGENIERÍA EN SISTEMAS COMPUTACIONALES
    </a>
  </div>

  <hr>


  <div class="btn-section">
    
    <a href="assets/reticulas/Malla curricular_IIA (Actual)Proxima a liquidar.pdf" target="_blank" class="btn-doc">
      📊 Retícula
    </a>
  </div>

  <!-- CONTACTO  -->
  <section class="contact-section">

    <div class="contact-row">

      <div class="contact-card">
        <h3>■ JEFA DE DIVISIÓN</h3>
        <p class="name">Mtra. Yolanda del Carmen Estrella Pérez</p>
        <p>E-mail: <a href="mailto:divisionif@itsescarcega.edu.mx">divisioniia@itsescarcega.edu.mx</a></p>
        <P> Telefono:9821183526 </P>
      </div>
      <!-- 
     <div class="contact-card">
        <h3>■ COORDINADORA</h3>
        <p class="name">Lic. Ana Dalia Antonio Ordoñez</p>
        <p>E-mail: <a href="mailto:coordinacionisc@itsescarcega.edu.mx">coordinacionisc@itsescarcega.edu.mx</a></p>
        <p> Telefono:9828291780</p>
      </div>  -->

    </div>

  </section>

</div>